const initialState = {     
      statusType: 'ALL',
	filterText: '',
      emailAddressId: '',
      emailAddressName: '',
      phoneNumberId: '',
      phoneNumberName: ''
}

const healthCheckListFiltersReducer = (state = initialState, action) => {
      switch (action.type) {
            case 'SET_HEALTH_CHECK_LIST_FILTERS':
                  return {
                        ...state,
                        statusType: action.filters.statusType,
                        filterText: action.filters.filterText,
                        emailAddressId: action.filters.emailAddressId,
                        phoneNumberId: action.filters.phoneNumberId
                  }
            case 'UPDATE_CURRENT_USER':
            case 'LOGOUT_USER':
                  return {
                        statusType: 'ALL',
                        filterText: '',
                        emailAddressId: '',
                        emailAddressName: '',
                        phoneNumberId: '',
                        phoneNumberName: ''
                  }
            default:
                  return state;
      }

};
export default healthCheckListFiltersReducer;
